export default "__VITE_ASSET__BuZKVheY__"